var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-jumbotron",
    { attrs: { fluid: "" } },
    [
      _c("template", { slot: "header" }, [_vm._v("\n  Add New Module\n  ")]),
      _c(
        "div",
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { sm: "7" } },
                [
                  _c(
                    "b-input-group",
                    [
                      _c("b-form-input", {
                        attrs: { type: "text", placeholder: "New Module Name" },
                        model: {
                          value: _vm.newModule,
                          callback: function($$v) {
                            _vm.newModule = $$v
                          },
                          expression: "newModule"
                        }
                      }),
                      _c(
                        "b-input-group-append",
                        [
                          _c(
                            "b-btn",
                            {
                              attrs: { variant: "outline-success" },
                              on: {
                                click: function($event) {
                                  _vm.addNewModule()
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n              + Add New Module Name\n            "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("br"),
      _c("hr"),
      _vm._l(this.$store.state.management.moduleNames, function(item, index) {
        return _c(
          "b-row",
          { key: index, staticClass: "list" },
          [
            _c(
              "b-col",
              { staticClass: "list", attrs: { cols: "4" } },
              [
                index != 0
                  ? _c(
                      "b-alert",
                      { attrs: { show: "" } },
                      [
                        _vm._v(
                          "\n        " + _vm._s(item["value"]) + "\n        "
                        ),
                        _c(
                          "b-btn",
                          {
                            staticClass: "remove-btn",
                            attrs: { variant: "outline-danger" },
                            on: {
                              click: function($event) {
                                _vm.removeModuleName(item)
                              }
                            }
                          },
                          [_vm._v("\n          Remove\n        ")]
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            )
          ],
          1
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c06d2e9e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c06d2e9e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/dashboard/management/addNewModule.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-c06d2e9e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/dashboard/management/addNewModule.vue
// module chunks = 0